import { defineMessages, MessageDescriptor, IntlShape } from 'react-intl';

export default defineMessages({
  activePolicyStatus: {
    id: 'policyStatus.active',
    defaultMessage: 'Active',
  },
  modifyPolicyholder: {
    id: 'modifyPolicyHolder',
    defaultMessage: 'Modify Policyholder',
  },
  confirmedPolicyStatus: {
    id: 'policyStatus.confirmed',
    defaultMessage: 'Confirmed',
  },
  completedPolicyStatus: {
    id: 'policyStatus.completed',
    defaultMessage: 'Completed',
  },
  cancelledPolicyStatus: {
    id: 'policyStatus.cancelled',
    defaultMessage: 'Cancelled',
  },
  dateRange: {
    id: 'dateRange',
    defaultMessage: '{startDate} to {endDate}',
  },
  insuredLabelDefault: {
    id: 'insuredLabel.default',
    defaultMessage: '{itemCount, plural, one {Item} other {Items}} insured',
  },
  insuredLabelTravel: {
    id: 'insuredLabel.travel',
    defaultMessage: '{itemCount, plural, one {Person} other {People}} insured',
  },
  insuredLabelProduct: {
    id: 'insuredLabel.product',
    defaultMessage: '{itemCount, plural, one {Product} other {Products}} insured',
  },
  insuredLabelParcel: {
    id: 'insuredLabel.parcel',
    defaultMessage: '{itemCount, plural, one {Shipment} other {Shipments}} covered',
  },
  insuredLabelLocation: {
    id: 'insuredLabel.location',
    defaultMessage: 'Insured {itemCount, plural, one {location} other {locations}}',
  },
  insuredLabelEvent: {
    id: 'insuredLabel.event',
    defaultMessage: '{itemCount, plural, one {Event} other {Events}} covered',
  },
  insuredItemParcel: {
    id: 'insuredItem.parcel',
    defaultMessage: 'Order #',
  },
  insuredItemTracker: {
    id: 'insuredItem.tracker',
    defaultMessage: 'Tile Serial #:',
  },
  insuredLabelShopee: {
    id: 'insuredLabel.shopee',
    defaultMessage: '{itemCount, plural, one {Product} other {Products}} covered',
  },
  error: {
    id: 'error',
    defaultMessage: 'Sorry! Something went wrong. Please try again later.',
  },
  NotAuthorizedException: {
    id: 'NotAuthorizedException',
    defaultMessage: 'Incorrect username or password.',
  },
  paymentDateLabel: {
    id: 'bookingCard.paymentDateLabel',
    defaultMessage: 'Payment date',
  },
  referenceNo: {
    id: 'bookingDetailsCard.referenceNo',
    defaultMessage: 'Reference No',
  },
  bookingTitleLabel: {
    id: 'bookingCard.bookingTitleLabel',
    defaultMessage: 'Your trip from {pickupAddress}',
  },
  coverageDatesLabel: {
    id: 'bookingCard.coverageDatesLabel',
    defaultMessage: '{policyEndDate, plural, one {Coverage date} other {Coverage dates}}',
  },
  policyPeriodLabel: {
    id: 'bookingCard.policyPeriodLabel',
    defaultMessage: 'Policy period',
  },
  priceLabel: {
    id: 'bookingCard.priceLabel',
    defaultMessage: 'Price/Premium',
  },
  priceOnlyLabel: {
    id: 'bookingCard.priceOnlyLabel',
    defaultMessage: 'Price',
  },
  renewalLabel: {
    id: 'bookingCard.renewalLabel',
    defaultMessage: 'Renewal',
  },
  valueMultipleDates: {
    id: 'bookingCard.valueMultipleDates',
    defaultMessage: 'Varied',
  },
  completeForm: {
    id: 'form.completeForm',
    defaultMessage: 'Please fix the errors highlighted in the fields below',
  },
  emailLabel: {
    id: 'emailLabel',
    defaultMessage: 'Email',
  },
  submitButtonText: {
    id: 'submitButtonText',
    defaultMessage: 'Submit',
  },
  phoneVerified: {
    id: 'phoneVerified',
    defaultMessage: 'Your phone number has been verified and can be used to login.',
  },
  emailVerified: {
    id: 'emailVerified',
    defaultMessage: 'Your email has been verified and can be used to login.',
  },
  email: {
    id: 'email',
    defaultMessage: 'email',
  },
  SMS: {
    id: 'SMS',
    defaultMessage: 'SMS',
  },
  policyLengthInYears: {
    id: 'policyLengthInYears',
    defaultMessage: '{coverageLength, number} {coverageLength, plural, one {year} other {years}}',
  },
  customer: {
    id: 'customer',
    defaultMessage: 'Customer',
  },
  insuredLabelPet: {
    id: 'insuredLabel.pet',
    defaultMessage: 'Pet Protection',
  },
  ssAsiaLimit: {
    id: 'ssAsiaLimit',
    defaultMessage: '90% of the unused flight fares',
  },
  includedLimit: {
    id: 'benefitsTable.limitDescription.includedLimit',
    defaultMessage: 'Included in limit above',
  },
  wantToChangeYourProtection: {
    id: 'help.wantToChangeYourProtection',
    defaultMessage: 'Want to change or cancel your protection?',
  },
  manageYourProtection: {
    id: 'help.manageYourProtection',
    defaultMessage: 'Manage your protection',
  },
  cantFindAnAnswer: {
    id: 'help.cantFindAnAnswer',
    defaultMessage: `Can't find an answer`,
  },
  contactUsViaForm: {
    id: 'help.contactUsViaForm',
    defaultMessage: `Contact us via our form`,
  },
  contactLinkText: {
    id: 'contactLinkText',
    defaultMessage: 'Contact us',
  },
  helpCenter: {
    id: 'help.helpCenter',
    defaultMessage: `Help centre`,
  },
  policyIsCancelled: {
    id: 'fnol.getStartedForm.policyIsCancelled',
    defaultMessage:
      'Your policy was cancelled, as a result it’s no longer possible to make a claim. If you need further support, you can check out the {helpCentre}, reply to any of our emails or use {link} to contact our friendly staff.',
  },
  policyWording: {
    id: 'policyWording',
    defaultMessage: 'policy wording',
  },
});

function formatPartnerMessage(
  intl: IntlShape,
  descriptor: MessageDescriptor,
  slug: string | undefined,
  value?: Record<string, any>,
): string {
  const defaultMessage = intl.formatMessage(descriptor, value);
  if (!slug) {
    return defaultMessage;
  }
  const descriptorId = descriptor.id;
  const partnerDescriptorId = `partners.${slug}.${descriptorId}`;
  const partnerMessage = intl.formatMessage(
    {
      id: partnerDescriptorId,
      defaultMessage,
    },
    value,
  );

  return partnerMessage === partnerDescriptorId ? defaultMessage : partnerMessage;
}

export { formatPartnerMessage };
